import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import {
  componentItemsEqual,
  getComponentItemValue,
} from 'pubweb-smokey/dist/utils/utils';
import { RadioButtonGroupStyles } from './RadioButtonGroup.styled';
import RadioButton from './RadioButton';

const RadioButtonGroup = React.forwardRef(function RadioButtonGroup(
  {
    disabled,
    automationId,
    onChange,
    handleChange,
    isLayoutHorizontal,
    items,
    id,
    radioButtonOptions,
    selectedItem,
    defaultValue,
    selectedValue,
    ...props
  },
  ref
) {
  const getItemFromValue = (value) => {
    if (value === undefined || value === null) {
      return null;
    }
    return items.filter((i) => getComponentItemValue(i) == value)[0];
  };

  const propertyClasses = [];
  const [currentSelectedItem, setCurrentSelectedItem] = useState(
    getItemFromValue(defaultValue) ||
      getItemFromValue(selectedValue) ||
      selectedItem
  );

  useEffect(() => {
    if (selectedItem) {
      setCurrentSelectedItem(selectedItem);
    }
    //eslint-disable-next-line
  }, [selectedItem]);

  useEffect(() => {
    if (selectedValue) {
      setCurrentSelectedItem(getItemFromValue(selectedValue));
    }
    //eslint-disable-next-line
  }, [selectedValue]);

  propertyClasses.push(disabled ? 'disabled' : '');
  propertyClasses.push(isLayoutHorizontal ? 'horizontal' : 'vertical');

  return (
    <RadioButtonGroupStyles {...props} className={propertyClasses.join(' ')}>
      {(items || radioButtonOptions).map((item) => {
        return (
          <RadioButton
            id={`${id}-radio-${item.value !== undefined ? item.value : item}`}
            key={`${id}-radio-${item.value !== undefined ? item.value : item}`}
            name={id}
            automationId={
              automationId || `${id}-radio-${getComponentItemValue(item)}`
            }
            disabled={disabled}
            label={item.text || item.label || item}
            value={getComponentItemValue(item)}
            checked={componentItemsEqual(currentSelectedItem, item)}
            className={
              componentItemsEqual(currentSelectedItem, item) ? 'selected' : ''
            }
            onChange={(e) => {
              if (e.target.checked) {
                // this is to make sure onChange on gets called once rather than the radio button just checked and the one unchecked
                const newSelectedItem = getItemFromValue(e.target.value);
                setCurrentSelectedItem(newSelectedItem);

                if (handleChange) {
                  handleChange(e);
                } else if (onChange) {
                  //onChange will pass the value that was just selected back to the radio button
                  onChange(newSelectedItem);
                }
              }
            }}
            ref={ref}
          />
        );
      })}
    </RadioButtonGroupStyles>
  );
});

RadioButtonGroup.defaultProps = {
  disabled: false,
  automationId: '',
  onChange: null,
  isLayoutHorizontal: false,
  items: [],
  id: '',
  defaultItem: null,
  selectedItem: null,
  defaultValue: '',
  selectedValue: '',
};

RadioButtonGroup.propTypes = {
  disabled: PropTypes.bool,
  automationId: PropTypes.string,
  onChange: PropTypes.func,
  isLayoutHorizontal: PropTypes.bool,
  items: PropTypes.array,
  id: PropTypes.string,
  defaultItem: PropTypes.any,
  selectedItem: PropTypes.any,
  defaultValue: PropTypes.string,
  selectedValue: PropTypes.any,
  handleChange: PropTypes.func,
  radioButtonOptions: PropTypes.array,
};

export default RadioButtonGroup;
